module.exports = __webpack_public_path__ + "img/centro-relevos.a7b0f862.svg";